import {
	API_SPACE_ID,
	API_TOKEN,
	API_ENV,
	API_HOST,
	MAPPING_ID
} from './config';

const contentful = require('contentful');

/**
 * CMS
 * Abstraction to our use of contentful
 */
class cms {
	constructor() {
		// fetch all the mappings
		this.mappings = [];
		// create the connection
		this.client = contentful.createClient({
			space: API_SPACE_ID,
			accessToken: API_TOKEN,
			environment: API_ENV,
			host: API_HOST
		});
	}

	/**
	 * Update Mapping
	 * Get the mapping file from contentful
	 */
	updateMapping() {
		// fetch the mappings
		return this.client.getEntry(MAPPING_ID).then(response => {
			// cast the mappings file to the local mappings object
			this.mappings = response.fields.body;
		}).catch((err) => {
			console.error(`Failed to load the mappings from contentful`, err);
		});
	}

	/**
	 * # Get
	 * Get the key from contenful where the key is a plain text string of the 
	 * data from the mapping file in contentful
	 *
	 * ## Useage
	 * `cms.get('hello', 'fallback')`
	 *
	 * Don't forget to supply a fallback function
	 * 
	 * @param  {string} key      The key to fetch
	 * @param  {any} fallback    The fall back data, this can be an object
	 * @return {Promise}         Returns a promise
	 */
	get(key, fallback) {
		return new Promise((resolve, reject) => {
			// this was original an async function but trying to implement into
			// old react code is a nightmare so i have rewritten it to use promises
			const getEntry = () => {
				// find the key in the mappings
				if (typeof this.mappings[key] === 'undefined') {
					console.error(`Unable to find mapping for ${key}, returning the default instead`);
					resolve(fallback);
				}

				// make the request to contentful
				this.client.getEntry(this.mappings[key]).then((response) => {
					resolve(response.fields);
				}).catch((err) => {
					console.error(err);
					// fallback to the data
					resolve(fallback);
				})
			}

			// fetch the mappings if we don't have them
			if (this.mappings.length === 0) {
				this.updateMapping().then(() => {
					getEntry();
				});
			} else {
				getEntry();
			}
		});
	}
}

export default new cms();